import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [error, setError] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (password !== confirm) {
            setError("Passwords don't match");
            return;
        }
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            setDone(true);
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail));
        } finally {
            setBusy(false);
        }
    };

    return (
        <main className="min-h-[60vh] bg-slate-50 flex items-center justify-center px-4" data-testid="reset-page">
            <div className="bg-white rounded-2xl border border-slate-200 p-8 max-w-md w-full">
                <h1 className="font-heading text-2xl font-extrabold text-slate-900 text-center mb-6">Choose a New Password</h1>
                {done ? (
                    <div className="text-center" data-testid="reset-success">
                        <p className="text-green-700 font-bold mb-4">Your password has been updated.</p>
                        <Link to="/account" className="text-[#0033A0] font-bold hover:underline" data-testid="reset-login-link">
                            Sign in with your new password
                        </Link>
                    </div>
                ) : (
                    <>
                        {!token && <p className="mb-4 text-sm text-red-600" data-testid="reset-no-token">This reset link is missing its token — use the link from your email.</p>}
                        {error && <p className="mb-4 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3" role="alert" data-testid="reset-error">{error}</p>}
                        <form onSubmit={submit} className="space-y-4">
                            <div>
                                <label htmlFor="reset-pw" className="text-sm font-bold text-slate-900">New password (min 8 characters)</label>
                                <input id="reset-pw" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
                                    className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0033A0]" data-testid="reset-password" />
                            </div>
                            <div>
                                <label htmlFor="reset-pw2" className="text-sm font-bold text-slate-900">Confirm password</label>
                                <input id="reset-pw2" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
                                    className="w-full rounded-xl border border-slate-200 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0033A0]" data-testid="reset-confirm" />
                            </div>
                            <button type="submit" disabled={busy || !token} data-testid="reset-submit"
                                className="w-full rounded-full bg-[#0033A0] py-3 font-heading font-bold text-white hover:bg-[#002277] disabled:opacity-50">
                                {busy ? "Updating…" : "Update Password"}
                            </button>
                        </form>
                    </>
                )}
            </div>
        </main>
    );
}
